export default __webpack_public_path__ + "ddd610abc93a44680c336834fd2edc54.png";